import { Box, LinearProgress } from '@planitgeo/treeplotter-ui-library';
import MapIcon from '@mui/icons-material/Map';

const animatedMapIconStyles = {
  'icon-progress': {
    position: 'absolute',
    bottom: '-1px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '24px',
    height: '2px',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'common.white',
    },
    '& .MuiLinearProgress-bar1Indeterminate': {
      animationDuration: '1.5s',
    },
    '& .MuiLinearProgress-bar2Indeterminate': {
      animationDuration: '1.5s',
    },
  },
};

type AnimatedMapIconProps = {
  isLoading: boolean;
};

export default function AnimatedMapIcon({ isLoading }: AnimatedMapIconProps) {
  if (isLoading) {
    return (
      <Box
        position="relative"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <MapIcon
          sx={{
            color: 'common.white',
            '@keyframes mapPulse': {
              '0%': { opacity: 0.5 },
              '25%': { opacity: 0.625 },
              '50%': { opacity: 0.75 },
              '75%': { opacity: 0.875 },
              '100%': { opacity: 1 },
            },
            animation: 'mapPulse 1.5s ease-in-out infinite',
          }}
        />
        <LinearProgress
          data-testid="map_loading_progress"
          sx={animatedMapIconStyles['icon-progress']}
          aria-label="Loading map"
        />
      </Box>
    );
  }

  return <MapIcon sx={{ color: 'common.white' }} />;
}
